import React from "react";

import { AuthProvider } from "./contexts/authContext";
import { CartProvider } from "./contexts/cartContext";
import { ConfirmationProvider } from "./contexts/confirmationContext";

import { AppRoutes, AuthConsumer } from "./routes/index";

import ErrorBoundary from "./components/errorBoundary.jsx";
import { NotificationProvider } from "./components/notification";
import TokenExpirationModal from "./components/tokenExpirationModal";

/**
 * The main application component.
 * It wraps the entire app with the AuthProvider for authentication context,
 * ErrorBoundary for error handling, and AuthConsumer to handle the loading state.
 */
function App() {
  return (
    <ErrorBoundary>
      <NotificationProvider>
        <AuthProvider>
          <ConfirmationProvider>
            <CartProvider>
              <TokenExpirationModal />
              <AuthConsumer>{({ loading }) => <AppRoutes />}</AuthConsumer>
            </CartProvider>
          </ConfirmationProvider>
        </AuthProvider>
      </NotificationProvider>
    </ErrorBoundary>
  );
}

export default App;
